import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";

export function useProfile() {
  return useQuery({
    queryKey: ["profile"],
    queryFn: async () => (await api.get("/me/profile")).data,
  });
}

export function useUserState() {
  return useQuery({
    queryKey: ["state"],
    queryFn: async () => (await api.get("/me/state")).data,
  });
}

export function useToggleAction() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ action_id, done }) =>
      (await api.post("/actions/toggle", { action_id, done })).data,
    onMutate: async ({ action_id, done }) => {
      await qc.cancelQueries({ queryKey: ["state"] });
      const prev = qc.getQueryData(["state"]);
      qc.setQueryData(["state"], (old) =>
        old ? { ...old, actions: { ...old.actions, [action_id]: done } } : old
      );
      return { prev };
    },
    onError: (_e, _v, ctx) => {
      if (ctx?.prev) qc.setQueryData(["state"], ctx.prev);
    },
    onSuccess: (data) => {
      qc.setQueryData(["state"], (old) => (old ? { ...old, ...data } : old));
    },
  });
}

export function useSetReminder() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ enabled, time }) =>
      (await api.post("/me/reminder", { enabled, time })).data,
    onSuccess: (data) => {
      qc.setQueryData(["state"], (old) => (old ? { ...old, reminder: data.reminder } : old));
    },
    onError: () => {
      qc.invalidateQueries({ queryKey: ["state"] });
    },
  });
}
